import axios from 'axios';
import axiosInstance from '../utils/axiosConfig';

export interface Game {
  id: number;
  title: string;
  difficulty: string;
  category_id: number;
  pick_color: string;
  progress: {
    completed_variations: number;
    total_variations: number;
    accuracy: number;
    correct_moves: number;
    wrong_moves: number;
    total_moves: number;
    completion_rate: number;
  };
}

export const getGames = async (): Promise<Game[]> => {
  try {
    const response = await axiosInstance.get('/chess/games');
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || '获取游戏列表失败');
    }
    throw error;
  }
};

export const startGame = async (gameId: number, selectedColor: 'white' | 'black' = 'white') => {
  try {
    const response = await axiosInstance.post('/chess/start_game', {
      gameId,
      selectedColor
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || '开始游戏失败');
    }
    throw error;
  }
};

export const validateMove = async (sessionId: string, move: string) => {
  try {
    const response = await axiosInstance.post('/chess/validate_move', {
      sessionId,
      move
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || '验证移动失败');
    }
    throw error;
  }
};

export const getHint = async (sessionId: string) => {
  try {
    const response = await axiosInstance.post('/chess/hint', {
      sessionId
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || '获取提示失败');
    }
    throw error;
  }
};



export const getGameStats = async (gameId: number) => {
  try {
    const response = await axiosInstance.get(`/chess/games/${gameId}/stats`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message || '获取统计数据失败');
    }
    throw error;
  }
};

export const resetGame = async (sessionId: string, gameId: number) => {
  try {
    const response = await axiosInstance.post('/chess/reset_game', {
      sessionId,
      gameId
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message || '重置游戏失败');
    }
    throw error;
  }
}; 